/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { isMeasurementType } from 'utils/viewOptionUtil'
import { SocialWebTimelineWidget as SocialWebTimelineWidgetType } from 'schemas/SocialWebTimelineWidgetSchema'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { getLabel } from 'utils/widgetTypeUtil'

import Timeline from '../../share/TopicsMode/Timeline'
import TopicsModeWidgetDataGuards from '../../share/TopicsMode/guards/TopicsModeWidgetDataGuards'
import { WidgetLoadingGuard } from '../../../share/guards'
import WidgetSettingGuards from './guards/WidgetSettingGuards'
import RunSearchEffect from './searches/RunSearchEffect'
import RunVOCSearchEffect from './searches/RunVOCSearchEffect'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../share/InsightModal/hooks/useSelectedInsights'

const SocialWebTimelineWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebTimelineWidgetType>(widgetId)
  const {
    isModalOpen,
    onClick,
    onClickChart,
    onSelection,
    onClose,
    selectedInsights,
    widgetSettingWithSelectedInsights
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <WidgetSettingGuards widgetId={widgetId}>
        {isMeasurementType(widgetSettingWithSelectedInsights.viewOption!) ? (
          <RunVOCSearchEffect widgetId={widgetId}>
            <WidgetLoadingGuard widgetId={widgetId}>
              <TopicsModeWidgetDataGuards widgetId={widgetId}>
                <Timeline
                  widgetId={widgetId}
                  onClickPoint={onClick}
                  onClickChart={onClickChart}
                  onSelection={onSelection}
                />
              </TopicsModeWidgetDataGuards>
            </WidgetLoadingGuard>
          </RunVOCSearchEffect>
        ) : (
          <RunSearchEffect widgetId={widgetId}>
            <WidgetLoadingGuard widgetId={widgetId}>
              <TopicsModeWidgetDataGuards widgetId={widgetId}>
                <Timeline
                  widgetId={widgetId}
                  onClickPoint={onClick}
                  onClickChart={onClickChart}
                  onSelection={onSelection}
                />
              </TopicsModeWidgetDataGuards>
            </WidgetLoadingGuard>
          </RunSearchEffect>
        )}
      </WidgetSettingGuards>
      <InsightModal
        title={
          widgetSettingWithSelectedInsights?.name ||
          getLabel(widgetSettingWithSelectedInsights?.type)
        }
        open={isModalOpen}
        onClose={onClose}
        selectedInsights={selectedInsights}
        widgetSetting={widgetSettingWithSelectedInsights}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebTimelineWidget
